export default __webpack_public_path__ + "static/media/kms-image-ori.5a6ee018.png";